import { render, staticRenderFns } from "./AddMasterToGroupClassDialog.vue?vue&type=template&id=5bfb89da"
import script from "./AddMasterToGroupClassDialog.vue?vue&type=script&lang=js"
export * from "./AddMasterToGroupClassDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports